import EmblaCarousel from 'embla-carousel';

const section = document.querySelector('.locations');
const locationsContainer = document.querySelector('.locations-items');
const mapLocationsContainer = document.querySelector('.map-locations');
const filterForm = document.querySelector('.filter');
const filterToggle = document.querySelector('.filter-toggle');
const loadMoreContainer = document.querySelector('.load-more');
const loadMoreBtn = document.querySelector('.load-more-btn');
let pageNumberInput = document.querySelector('#page-number');
let filteredFlagInput = document.querySelector('#filtered-flag');

let debounceTimeout;
let filterAbortController = null;
let latestRequestId = 0;

function initializeCategories() {
    const container = document.querySelector('.filter-categories');

    if (!container) return;

    const slider = EmblaCarousel(container, { align: 'start', dragFree: true });
    const items = container.querySelectorAll('.filter-category');

    items.forEach(item => {
        item.addEventListener('click', () => {
            const input = item.querySelector('input');
            const isActive = item.classList.contains('active');

            input.checked = !isActive;

            executeFilter({ appendFetchedItems: false });
        });
    });
}

function initializeDropdowns() {
    const dropdownTriggers = document.querySelectorAll('.filter-dropdown-trigger');
    const resetButtons = document.querySelectorAll('.filter-reset');

    dropdownTriggers.forEach(trigger => {
        const dropdownId = trigger.getAttribute('aria-controls');
        const dropdown = document.getElementById(dropdownId);

        trigger.addEventListener('click', () => {
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
            trigger.setAttribute('aria-expanded', String(!isExpanded));
            dropdown.hidden = isExpanded;
        });
    });

    resetButtons.forEach(button => {
        button.addEventListener('click', () => {
            const dropdown = button.closest('.filter-dropdown');
            const resetOption = dropdown.querySelector('input[type="radio"][value=""], input[type="checkbox"][value=""]');

            if (resetOption) {
                resetOption.checked = true;
            }

            executeFilter({ appendFetchedItems: false });
        });
    });
}

document.addEventListener('click', e => {
    document.querySelectorAll('.filter-dropdown-trigger[aria-expanded="true"]').forEach(trigger => {
        const dropdown = document.getElementById(trigger.getAttribute('aria-controls'));

        if (dropdown && !trigger.contains(e.target) && !dropdown.contains(e.target)) {
            trigger.setAttribute('aria-expanded', 'false');
            dropdown.hidden = true;
        }
    });
});

function initializeToggle() {
    const filterToggle = document.querySelector('.filter-toggle');
    const filterList = document.querySelector('.filter-list');

    filterToggle?.addEventListener('click', () => {
        filterList.classList.toggle('visible');
    });
}

function executeFilter({ appendFetchedItems = false, url = null }) {
    clearTimeout(debounceTimeout);

    filterAbortController?.abort();
    filterAbortController = new AbortController();
    const requestId = ++latestRequestId;

    section.classList.add('loading');

    // Update the page number input value
    if (appendFetchedItems) {
        pageNumberInput.value = parseInt(pageNumberInput.value) + 1;
    } else {
        pageNumberInput.value = 1;
    }

    // If no URL is provided, build the URL from the form data
    if (!url) {
        const formData = new FormData(filterForm);

        if (!formData.get('capacity') && !formData.get('event_type') && !formData.get('place') && !formData.get('search')) {
            formData.set('filtered', 0);
        }

        const searchParams = new URLSearchParams(formData);
        url = `${filterForm.action}?${searchParams.toString()}`;
    }
    
    fetch(url, { signal: filterAbortController.signal })
        .then(response => response.text())
        .then(html => {
            if (requestId !== latestRequestId) {
                return;
            }

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            const newFilterForm = tempDiv.querySelector('.filter');
            const newLocations = tempDiv.querySelector('.locations-items');
            const newMapLocations = tempDiv.querySelector('.map-locations');
            const newLoadMore = tempDiv.querySelector('.load-more');

            const activeElement = document.activeElement;
            const searchInput = filterForm.querySelector('input[type="search"]');
            const searchInputFocused = activeElement === searchInput;
            const searchValue = searchInputFocused ? searchInput.value : null;
            const caretPosition = searchInputFocused ? searchInput.selectionStart : null;

            if (appendFetchedItems) {
                locationsContainer.innerHTML += newLocations?.innerHTML;
                mapLocationsContainer.innerHTML += newMapLocations?.innerHTML;
            } else {
                locationsContainer.innerHTML = newLocations?.innerHTML;
                mapLocationsContainer.innerHTML = newMapLocations?.innerHTML;
            }

            loadMoreContainer.classList.toggle('visible', newLoadMore && newLoadMore.classList.contains('visible'));
            filterForm.innerHTML = newFilterForm.innerHTML;

            if (searchInputFocused) {
                const newSearchInput = filterForm.querySelector('input[type="search"]');

                if (newSearchInput) {
                    newSearchInput.value = searchValue;
                    newSearchInput.focus();
                    newSearchInput.setSelectionRange(caretPosition, caretPosition);
                }
            }

            // Re-acquire references to the hidden inputs after replacing the form HTML,
            // because the old DOM nodes are now detached and stale.
            pageNumberInput = document.querySelector('#page-number');
            filteredFlagInput = document.querySelector('#filtered-flag');

            // Dispatch a custom event to notify the map script that the locations have been updated
            document.dispatchEvent(new CustomEvent('locationsUpdated'));

            section.classList.remove('loading');
            initializeCategories();
            initializeDropdowns();
            initializeToggle();
        })
        .catch(error => {
            if (error.name === 'AbortError') {
                return;
            }

            section.classList.remove('loading');
            console.error('Failed to load results:', error);
        });

    const urlObj = new URL(url);

    if (!urlObj.searchParams.has('load_all')) {
        urlObj.searchParams.set('load_all', '1');
    }

    history.pushState(null, '', urlObj.toString());
}

// Handle form submission (for dropdowns with submit buttons)
filterForm.addEventListener('submit', e => {
    e.preventDefault();
    executeFilter({ appendFetchedItems: false });
});

// Handle filter form input
filterForm.addEventListener('input', e => {
    if (e.target.type === 'search') {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => executeFilter({ appendFetchedItems: false }), 500);
    }
});

// Handle load more button click
loadMoreBtn?.addEventListener('click', () => {
    executeFilter({ appendFetchedItems: true });
});

// Handle reset button click
locationsContainer.addEventListener('click', e => {
    if (e.target.classList.contains('locations-reset') || e.target.closest('.locations-reset')) {
        e.preventDefault();
        executeFilter({ appendFetchedItems: false, url: document.querySelector('.locations-reset').href });
    }
});

// Initialize things on page load
const randSeedInput = document.querySelector('#rand-seed');

if (randSeedInput && !randSeedInput.value) {
    randSeedInput.value = Math.floor(Math.random() * 2147483646) + 1;
}

initializeCategories();
initializeDropdowns();
initializeToggle();